import { Dialog, DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    background: theme.palette.grey['900'],
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    display: 'flex',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiPaper-root': {
      margin: 0,
      maxHeight: '100%',
      height: '100%',
      borderRadius: 0,
    },
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  width: '510px',
  height: '628px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: 'auto',
  },
}));
